/// <reference path="../../app.definition.ts" />

import * as angular from "angular";

interface ICallback {
    id: string;
    fn: (event: MouseEvent) => void;
}

export interface IClickService {
    registerClickCallback(id: string, fn: (event: MouseEvent) => void): void;
    unregisterClickCallback(id: string): void;
}

export class ClickService implements IClickService {
    private callbacks: ICallback[] = [];

    static $inject = ["$window"];
    constructor(private $window: ng.IWindowService) {
        angular.element($window).on('click', this.onClick);
    }

    private onClick = (event: JQueryEventObject): void => {
        // Iterate over a copy in case a callback unregisters itself or another callback
        [...this.callbacks].forEach(cb => {
            // The original browser event is a MouseEvent for a 'click'
            cb.fn(event.originalEvent as MouseEvent);
        });
    };

    public registerClickCallback(id: string, fn: (event: MouseEvent) => void): void {
        this.unregisterClickCallback(id);
        this.callbacks.push({ id, fn });
    }

    public unregisterClickCallback(id: string): void {
        const index = this.callbacks.findIndex(cb => cb.id === id);

        if (index > -1) {
            this.callbacks.splice(index, 1);
        }
    }
}

angular.module('eCareVault.common.services')
    .service('ClickService', ClickService);
